/**
 * Application logging — silent unless REACT_APP_VERBOSE_LOGS=true.
 * Keeps development consoles clean; turn verbose logs on when debugging.
 */
const verbose =
  typeof process !== 'undefined' && process.env.REACT_APP_VERBOSE_LOGS === 'true';

export function devLog(...args) {
  if (!verbose) return;
  // eslint-disable-next-line no-console
  console.log(...args);
}

export function devWarn(...args) {
  if (!verbose) return;
  // eslint-disable-next-line no-console
  console.warn(...args);
}

const devWarnOnceKeys = new Set();

/** Warn at most once per key per page session (only when verbose). */
export function devWarnOnce(key, ...args) {
  if (!verbose) return;
  if (!key || devWarnOnceKeys.has(key)) return;
  devWarnOnceKeys.add(key);
  // eslint-disable-next-line no-console
  console.warn(...args);
}
